var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDownIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 17 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.2441 11.3125q-.2793 0-.4941-.1934l-4.125-4.125q-.1934-.2148-.1934-.4941t.1934-.4941q.2149-.1935.4941-.1934.2793 0 .4942.1934L8.244 9.6582l3.6309-3.6523q.2148-.1935.4941-.1934.2793 0 .4941.1934.1934.2148.1934.4941t-.1934.4941l-4.125 4.125q-.2148.1934-.494.1934"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowDownIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-down-icon.2f813db1048a14c5adcedd339e34353c.svg";